__turbopack_context__.v({
  "jobDeliverableSelectFields": "OxA-7q_jobDeliverableSelectFields",
  "jobDeliverableSelectFields--horizontal": "OxA-7q_jobDeliverableSelectFields--horizontal",
  "jobDeliverableSelectFields--vertical": "OxA-7q_jobDeliverableSelectFields--vertical",
});
